import React, { useEffect, useState } from 'react';
import TechnicalConceptCreateView from '../views/TechnicalConceptCreateView';
import { CustomModal, useCustomToast } from '../../../../components';
import { useCreateTechnicalConcept } from '../../../../hooks/technicalConcept/technicalConcept';
import * as Yup from 'yup';
import { UploadedFile } from '../../../../utils';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';

import {
  useGetDependeciesByUserLogged,
} from '../../../../share';
import { useFormik } from 'formik';

import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import { Asset } from '../components/ModalAddItemActivo';

interface EntryRequestsCreateProps {
  isOpen: boolean;
  OnClose: () => void;
  dataTechnical?: any;
}

const TechnicalConceptCreateContainer: React.FC<EntryRequestsCreateProps> = ({
  isOpen,
  OnClose,
}) => {
  const [isOpenSaveChanges, setiIsOpenSaveChanges] = useState(false);

  const [files, setFiles] = React.useState<UploadedFile[]>();
  const [authData] = useAtom(authAtom);
  const [itemsAdded, setItemsAdded] = useState<Asset[]>([]);
  const [loadCreate, setLoadCreate] = useState(false);

  const { mutateAsync } = useCreateTechnicalConcept();
  const { showToast } = useCustomToast();
  const { data: dependenciesUser } = useGetDependeciesByUserLogged();

  const onSave = async (values: any) => {
    setLoadCreate(true);

    const formData = new FormData();
    formData.append('asset_type_id', String(values.asset_type_id || ''));
    formData.append('dependency_id', String(values.dependency_id || ''));
    formData.append('location_id', String(values.location_id || ''));
    formData.append('observations', String(values.observations || ''));

    formik.values.items.forEach((item, index) => {
      formData.append(
        `items[${index}][itemable_id]`,
        String(item.itemable_id)
      );
    });

    if (files?.length) {
      files.forEach((uploadedFile) => {
        if (uploadedFile.file instanceof File) {
          formData.append('documents[]', uploadedFile.file);
        }
      });
    }
    try {
      await mutateAsync(formData);

      showToast('success', 'Solicitud guardada exitosamente');
      onReset();
    } finally {
      setLoadCreate(false);
    }
  };

  const validationSchema = Yup.object({
    dependency_id: Yup.string().required('La dependencia es obligatoria'),
    location_id: Yup.string().required('La ubicación es obligatoria'),
  });

  const formik = useFormik({
    initialValues: {
      asset_type_id: '1',
      dependency_id: '',
      location_id: '',
      items: [] as { itemable_id: number }[],
      documents: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      await onSave(values);
    },
  });

  const validateAndOpenModal = async () => {
    const errors = await formik.validateForm();
    formik.setTouched(
      Object.keys(formik.values).reduce(
        (acc: Record<string, boolean>, key) => {
          acc[key] = true;
          return acc;
        },
        {} as Record<string, boolean>
      )
    );
    if (Object.keys(errors).length === 0) {
      setiIsOpenSaveChanges(true);
    }
  };

  const closeModalSaveChanges = () => {
    setiIsOpenSaveChanges(false);
  };

  const onResetItem = () => {
    formik.setFieldValue('item_id', '');
    formik.setFieldValue('item_quantity', '');
    formik.setFieldValue('observations', '');
  };
  const onReset = () => {
    closeModalSaveChanges();
    setTimeout(() => {
      formik.resetForm();
      onResetItem();
      OnClose();
      setFiles([]);
      setItemsAdded([]);
    }, 100);
  };

  useEffect(() => {
    if (dependenciesUser?.[0]?.id) {
      formik.setFieldValue('dependency_id', String(dependenciesUser[0].id));
    }
  }, [dependenciesUser, isOpen]);

  return (
    <CustomModal
      title="Nueva solicitud de concepto técnico"
      labelSubmit="Guardar solicitud"
      open={isOpen}
      onCancel={() => {
        onReset();
      }}
      width="95vw"
      isLoadingSave={loadCreate}
      onSave={validateAndOpenModal}
      disabledBtn={itemsAdded.length > 0 ? false : true}
    >
      <TechnicalConceptCreateView
        authData={authData}
        dependencies={dependenciesUser}
        formik={formik}
        onFiles={setFiles}
        files={files}
        itemsAdded={itemsAdded}
        setItemsAdded={setItemsAdded}
      />
      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de crear esta solicitud de concepto técnico?"
        textTwo="Una vez creado no podrá realizar cambios."
        open={isOpenSaveChanges}
        width={900}
        isLoadingSave={false}
        onClose={() => {
          closeModalSaveChanges();
        }}
        labelSubmit="Aceptar"
        onSave={formik.handleSubmit}
      />
    </CustomModal>
  );
};

export default TechnicalConceptCreateContainer;
